(() => {
  window.CCCart = {
    async add(items, trigger) {
      const drawer = document.querySelector('cart-drawer');
      const sections = drawer?.getSectionsToRender().map(section => section.id) || ['cart-icon-bubble'];
      const response = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections, sections_url: location.pathname })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || window.cartStrings.error);
      if (document.querySelector('main[data-template="cart"]')) { location.assign(window.routes.cart_url); return result; }
      document.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      if (drawer && result.sections?.['cart-drawer']) {
        drawer.classList.remove('is-empty');
        drawer.setActiveElement(trigger);
        drawer.renderContents(result);
      } else location.assign(window.routes.cart_url);
      document.dispatchEvent(new CustomEvent('cc:cart-added', { detail: result }));
      return result;
    }
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cc-set-add]');
    if (!button) return;
    const row = button.closest('[data-cc-set-item]');
    const input = row.querySelector('[data-cc-set-variant]');
    if (!input.value) { input.focus(); input.setCustomValidity(window.ccStrings.choose); input.reportValidity(); return; }
    input.setCustomValidity('');
    const error = row.querySelector('[data-cc-set-error]');
    button.disabled = true; error.hidden = true;
    try { await window.CCCart.add([{ id: Number(input.value), quantity: 1 }], button); }
    catch (failure) { error.textContent = failure.message; error.hidden = false; }
    finally { button.disabled = false; }
  });
  document.addEventListener('change', event => { if (event.target.matches('[data-cc-set-variant]')) event.target.setCustomValidity(''); });
  class CCRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.dataset.loaded) return;
      this.dataset.loaded = 'true';
      this.controller = new AbortController();
      fetch(this.dataset.url, { signal: this.controller.signal }).then(response => {
        if (!response.ok) throw new Error('Recommendations unavailable');
        return response.text();
      }).then(text => {
        const content = new DOMParser().parseFromString(text, 'text/html').querySelector('cc-recommendations');
        if (content) {
          if (this.closest('cc-case-product')) {
            content.querySelectorAll('[data-cc-set-add]').forEach(button => {
              const label = document.createElement('label'); label.className = 'cc-set-check';
              const checkbox = document.createElement('input'); checkbox.type = 'checkbox'; checkbox.dataset.ccSetCheck = '';
              label.append(checkbox, document.createTextNode(` ${button.textContent}`)); button.replaceWith(label);
            });
          }
          const unique = `cc-${Math.random().toString(36).slice(2)}`;
          content.querySelectorAll('select[id]').forEach((select,index) => {
            const label = content.querySelector(`label[for="${select.id}"]`);
            select.id = `${unique}-${index}`; if (label) label.htmlFor = select.id;
          });
          this.innerHTML = content.innerHTML;
        }
      }).catch(() => {});
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  if (!customElements.get('cc-recommendations')) customElements.define('cc-recommendations', CCRecommendations);
})();
